module.exports = __webpack_public_path__ + "img/batteryDesc_mobile.90fc0632.png";